if (!customElements.get('cart-countdown-banner')) {
  class CartCountdownBanner extends HTMLElement {
    constructor() {
      super();
      this.duration = parseInt(this.dataset.duration) || 300;
      this.variantId = this.dataset.variantId;
      this.timerInterval = null;
      this.storageKey = 'cart_banner_timer_end';
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (this.timerInterval) clearInterval(this.timerInterval);
    }

    init() {
      this.startTimer();
      // Optional: Add click listener to add to cart if needed
      // this.addEventListener('click', (e) => {
      //   if (this.isAdding) return;
      //   this.addToCart();
      // });
    }

    startTimer() {
      let endTime = sessionStorage.getItem(this.storageKey);
      const currentTime = Date.now();

      if (!endTime || parseInt(endTime) < currentTime) {
        endTime = currentTime + this.duration * 1000;
        sessionStorage.setItem(this.storageKey, endTime);
      } else {
        endTime = parseInt(endTime);
      }

      const hoursEl = this.querySelector('.js-timer-hours');
      const minutesEl = this.querySelector('.js-timer-minutes');
      const secondsEl = this.querySelector('.js-timer-seconds');

      const updateUI = () => {
        const now = Date.now();
        let timeLeft = Math.max(0, Math.floor((endTime - now) / 1000));

        const h = Math.floor(timeLeft / 3600);
        const m = Math.floor((timeLeft % 3600) / 60);
        const s = timeLeft % 60;

        if (hoursEl) hoursEl.textContent = h.toString().padStart(2, '0');
        if (minutesEl) minutesEl.textContent = m.toString().padStart(2, '0');
        if (secondsEl) secondsEl.textContent = s.toString().padStart(2, '0');

        if (timeLeft <= 0) {
          clearInterval(this.timerInterval);
          this.hideBanner();
        }
      };

      updateUI();
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval = setInterval(updateUI, 1000);
    }

    hideBanner() {
      this.style.display = 'none';
      sessionStorage.removeItem(this.storageKey);
      this.remove();
    }

    async addToCart() {
      if (!this.variantId) return;
      this.isAdding = true;
      this.style.opacity = '0.7';
      this.style.pointerEvents = 'none';

      try {
        const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
        const sectionsIds = sectionsToRender; // Shopify often expects section names

        const formData = {
          'id': this.variantId,
          'quantity': 1,
          'sections': sectionsIds,
          'sections_url': window.location.pathname
        };

        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        const state = await response.json();

        if (response.ok) {
          sessionStorage.removeItem(this.storageKey);

          // Use global publish if available (Shopify Dawn/standard pubsub)
          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-banner', cartData: state });
          }

          // Force update the drawer
          const cartDrawer = document.querySelector('cart-drawer');
          const cartDrawerItems = document.querySelector('cart-drawer-items');

          if (cartDrawer && state.sections) {
            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(state);
            } else if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
              cartDrawerItems.onCartUpdate();
            } else {
              // Fallback: reload sections manually
              location.reload();
            }
          }
        } else {
          console.error('Cart add error:', state.description || state.message);
        }
      } catch (error) {
        console.error('Error adding promo product:', error);
      } finally {
        this.isAdding = false;
        this.style.opacity = '1';
        this.style.pointerEvents = 'auto';
      }
    }
  }

  customElements.define('cart-countdown-banner', CartCountdownBanner);
}
